import moment from "moment";
import { Pill, PopOverMenu, Text } from "components/commons";
import { prettifyCashInChannel, prettifyCashInStatus } from "utils/pretty.utils";
import { formatAmount, formatPesoWithDecimalRange } from "utils";
import { CashInChannel, CashInStatus, DateTime } from "enums";

import styles from "./cashin.module.scss";
import { bankItems } from "enums/banks";
import BankProcessor from "enums/bank-processor";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import RedemptionStatus from "../../../enums/redemption-status";
import locale from "../../../localization";

// const displayCashinDate = (cashin) => {
//   const { status, fulfilledAt, expiresAt, createdAt } = cashin;
//   let date = null;
//   // todo: complete status date display when backend is ready
//   // need to finalize backend conditions in PRD
//   switch (status) {
//     case CashInStatus.Success:
//       date = fulfilledAt;
//       break;
//     case CashInStatus.Expired:
//       // issue encounter here, some "expired" status with expiresAt equal to null
//       date = expiresAt ? expiresAt : createdAt;
//       break;
//     default:
//       date = createdAt;
//   }
//   return moment(date).format(DateTime.G);
// };

export const mapDataToList = (
  cashins,
  setRemarks,
  voidTransactionModal,
  onVoidTransactionCb,
  updateRemarksApi,
  setValue,
  getUserAccess,
  currentUser,
) => {
  const {
    cashinId,
    referenceNumber,
    amount,
    locqFee,
    customerFee,
    fleet,
    cashinChannel,
    status,
    mode,
    createdAt,
    paymentProcessor,
    remarks,
  } = cashins;

  const SPI_VOIDABLE_CHANNELS = [
    CashInChannel.ManualBankDepositSPI,
    CashInChannel.WithholdingTaxRefundSurf,
    CashInChannel.Adjustment,
  ];

  const isWithinVoidWindow = moment().diff(moment(createdAt), "days") < 7;
  const isSpiChannel = SPI_VOIDABLE_CHANNELS.includes(cashinChannel);
  const isOwnedByCurrentUser = cashins.userId === currentUser?.userId;

  const options = [];

  // if (getUserAccess?.fullAccess || getUserAccess?.voidAccess) {
  //   if (
  //     status === RedemptionStatus.Success &&
  //     isWithinVoidWindow &&
  //     isSpiChannel &&
  //     isOwnedByCurrentUser
  //   ) {
  //     options.push({
  //       content: locale.voidCashin,
  //       onClick: () => {
  //         setRemarks("");
  //         voidTransactionModal.show({
  //           cashins,
  //           title: `${locale.voidCashin}?`,
  //           description: (
  //             <Text align="center">
  //               <locale.Populate
  //                 text={locale.voidingThisTransactionWillDeduct
  //               }
  //                 items={[<b>{formatPesoWithDecimalRange(amount, 2)}</b>]}
  //               />
  //             </Text>
  //           ),
  //           label: locale.reasonRemarks,
  //           actionText: locale.voidCashin,
  //           submit: (value) => {
  //             return onVoidTransactionCb({
  //               cashInItem: cashins,
  //               value,
  //             });
  //           },
  //         });
  //       },
  //     });
  //   }
  // }

  if (getUserAccess?.fullAccess || getUserAccess?.modifyAccess) {
    // if (status === CashInStatus.Voided) {
    //   options.push({
    //     content: locale.editRemarks,
    //     onClick: () => {
    //       setRemarks(remarks);
    //       setValue(prettifyVoidTransactionValue(remarks));
    //       voidTransactionModal.show({
    //         cashins,
    //         title: locale.editRemarks,
    //         description: null,
    //         label: locale.reasonRemarks,
    //         actionText: locale.save,
    //         submit: async (value) => {
    //           await updateRemarksApi.request({
    //             id: cashinId,
    //             remarks: value,
    //           });
    //           cashins.remarks = value;
    //           voidTransactionModal.close();
    //           setRemarks("");
    //         },
    //       });
    //     },
    //   });
    // }
  }

  const bank = bankItems[mode] || bankItems[paymentProcessor];
  const cashInMode = bank?.shortTitle || bank?.title || "";
  return {
    cashInId: cashinId,
    referenceNumber,
    remarks: (
      <>
        <Text>
          {remarks?.split("\n").map((line, i) => (
            <span key={i}>
              {line}
              <br />
              <br />
            </span>
          ))}
        </Text>
      </>
    ),
    amount: formatAmount(amount),
    cashInFeeLocq: formatAmount(locqFee),
    cashInFeeCustomer: formatAmount(customerFee),
    businessNameId: (
      <>
        <Text>{fleet?.businessName}</Text>
        <Text className={styles.subBusinessId}>{fleet?.shortName}</Text>
      </>
    ),
    cashInChannel: `${prettifyCashInChannel(cashinChannel)} ${
      cashInMode ? `(${cashInMode})` : ""
    }`.trim(),
    statusCashInDate: (
      <>
        <Pill
          sky={status === CashInStatus.Pending}
          deepRed={status === CashInStatus.Failed}
          grass={status === CashInStatus.Success}
          cement={status === CashInStatus.Expired || status === CashInStatus.Voided}
        >
          {prettifyCashInStatus(status)}
        </Pill>
        {/* <Text className={styles.subFulfilledDate}>{displayCashinDate(cashins)}</Text> */}
        <Text className={styles.subFulfilledDate}>{moment(createdAt).format(DateTime.G)}</Text>
      </>
    ),
    options:
      options.length > 0 ? (
        <PopOverMenu options={options}>
          <MoreVertIcon className={styles.icon} />
        </PopOverMenu>
      ) : (
        ""
      ),
  };
};

export const mapFilterToRequest = (filterState) => {
  const { cashinStatus, cashinChannel, ...fs } = filterState;
  const newCashinStatus = cashinStatus !== "all" ? cashinStatus : "";
  const newCashinChannel = cashinChannel !== "all" ? cashinChannel : "";

  const obj = {
    ...fs,
    cashinStatus: newCashinStatus,
    cashinChannel: newCashinChannel,
  };

  return obj;
};

export const apiMapper = (param) => {
  const obj = { ...param };
  if (
    [
      CashInChannel.OnlineBankDragonPay,
      CashInChannel.OnlineBankingBrankas,
      CashInChannel.OnlineBankBPI,
    ].includes(obj.cashinChannel)
  ) {
    obj.paymentProcessor =
      CashInChannel.OnlineBankBPI === obj.cashinChannel
        ? BankProcessor.BPI
        : CashInChannel.OnlineBankDragonPay === obj.cashinChannel
          ? BankProcessor.DragonPay
          : BankProcessor.Brankas;
    obj.cashinChannel = CashInChannel.OnlineBanking;
  }
  return { ...obj };
};
